import { useId, type ComponentProps } from 'react';

type FieldProps = ComponentProps<'input'> & {
  /** The label's words, from the dictionary. */
  label: string;
  /** A line under the input, read with it by screen readers. */
  hint?: string;
};

/** A labelled input, the forms' one building block: the label above, a hint under it. */
export function Field({ label, hint, id, ...input }: FieldProps) {
  const ownId = useId();
  const inputId = id ?? ownId;
  const hintId = hint === undefined ? undefined : `${inputId}-hint`;
  return (
    <div className="field">
      <label htmlFor={inputId}>{label}</label>
      <input id={inputId} aria-describedby={hintId} {...input} />
      {hint !== undefined && (
        <p id={hintId} className="field-hint">
          {hint}
        </p>
      )}
    </div>
  );
}
